var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import PropTypes from 'prop-types';
import { DragSource, DropTarget } from 'react-dnd';
const sourceSpec = {
    beginDrag(props) {
        return {
            dragItem: props
        };
    },
};
const targetSpec = {
    drop(props, monitor) {
        let targetItem = monitor.getItem();
        props.onChange ? props.onChange(props, targetItem.dragItem) : "";
    },
};
let DragCard = class DragCard extends React.Component {
    render() {
        const { id, text, isDragging, connectDragSource, connectDropTarget, className, } = this.props;
        const opacity = isDragging ? 0 : 1;
        return connectDragSource(connectDropTarget(<div className={`${className} drag-card-main`} style={{ opacity }} key={id}>{text}</div>));
    }
};
DragCard.propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    id: PropTypes.any.isRequired,
};
DragCard = __decorate([
    DragSource((props) => props.type, sourceSpec, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    })),
    DropTarget((props) => props.type, targetSpec, (connect) => ({
        connectDropTarget: connect.dropTarget(),
    }))
], DragCard);
export default DragCard;



// WEBPACK FOOTER //
// ./components/drag/DragCard.tsx